import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewChild,
  inject,
} from '@angular/core';
import { Modal } from '@spirit-testing/component-library';
import { ModalEscapeGuardDirective } from '../../components/modal-escape-guard/modal-escape-guard.directive';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { CustomerUserDTO, RoleDTO } from '../../models/customer.model';

@Component({
  selector: 'app-change-role-dialog',
  standalone: true,
  imports: [
    Modal,
    ModalEscapeGuardDirective,
    TranslatePipe,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatSelect,
    MatOption,
  ],
  templateUrl: './change-role-dialog.component.html',
  styleUrl: './change-role-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[attr.role]': "visible ? 'dialog' : null",
    '[attr.aria-modal]': "visible ? 'true' : null",
    '[attr.aria-label]': 'visible ? titel : null',
  },
})
export class ChangeRoleDialogComponent implements OnChanges, AfterViewInit {
  @Input() visible = false;
  @Input() user: CustomerUserDTO | null = null;
  @Input() roles: RoleDTO[] = [];
  @Input() busy = false;

  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() save = new EventEmitter<string>();
  @Output() dialogCancel = new EventEmitter<void>();

  @ViewChild('roleContent') roleContentTemplate!: TemplateRef<unknown>;

  private cdr = inject(ChangeDetectorRef);
  private translate = inject(TranslateService);

  roleControl = new FormControl<string>('');
  resolvedTemplate: TemplateRef<unknown> | null = null;

  ngAfterViewInit(): void {
    this.resolvedTemplate = this.roleContentTemplate;
    this.cdr.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges = {}): void {
    const nurBusy = 'busy' in changes && Object.keys(changes).length === 1;
    if (this.user && !nurBusy) {
      this.roleControl.setValue(this.user.roleId);
    }
  }

  get titel(): string {
    return this.translate.instant('changeRoleDialog.title');
  }

  get saveDisabled(): boolean {
    return !this.roleControl.value || this.roleControl.value === this.user?.roleId;
  }

  onSave(): void {
    if (this.roleControl.value) {
      this.save.emit(this.roleControl.value);
    }
  }

  onCancel(): void {
    this.dialogCancel.emit();
  }
}
